export const TRANSITION_DURATION_MS = 300;
export const TRANSITION_SCALE_ADJUSTMENT_Y = 0.2;
export const TRANSITION_SCALE_ADJUSTMENT_X = 0.5;
